import useCleverLoginButton from './useCleverLoginButton.hook';
import SignInButton from '../SignInButton/SignInButton';

export default function CleverLoginButton({
  text,
  redirectTo,
  redirectErrorTo,
  stateParams,
}) {
  const { state } = useCleverLoginButton({
    redirectTo,
    redirectErrorTo,
    stateParams,
  });

  return (
    <SignInButton
      url={state.loginUrl}
      text={text}
      logo={
        process.env.NEXT_PUBLIC_CLOUDFRONT_STATIC_HOST + '/img/clever-white.png'
      }
      logoAlt="Clever"
      logoWidth="64px"
      logoHeight="20px"
      provider="clever"
    />
  );
}
